type Json = Record<string, any> | any[];

export type CacheValue<T = any> = {
    value: T;
    expiresAt: number; // epoch ms
};

export class CacheStore {
    protected ns: string;
    private mem = new Map<string, CacheValue>();

    constructor(namespace = 'appCache/v1') {
        this.ns = namespace;
    }

    private k(key: string) {
        return `${this.ns}:${key}`;
    }

    getNameSpace() {
        return this.ns;
    }
    getAvailableKeys() {
        return Array.from(this.mem.keys());
    }

    clearAll() {
        this.mem.clear();
    }

    get<T = Json>(key: string): T | null {
        const now = Date.now();

        // 1) memoria
        const m = this.mem.get(key);
        if (m) {
            if (m.expiresAt > now) return m.value as T;
            this.mem.delete(key);
        }

        // 2) localStorage
        try {
            const raw = localStorage.getItem(this.k(key));
            if (!raw) return null;
            const parsed = JSON.parse(raw) as CacheValue<T>;
            if (parsed.expiresAt > now) {
                // hidrata memoria para el resto de la sesión
                this.mem.set(key, parsed);
                return parsed.value;
            }
            localStorage.removeItem(this.k(key));
        } catch {
            // ignora
        }
        return null;
    }

    set<T = Json>(key: string, value: T, ttlMs: number) {
        const entry: CacheValue<T> = { value, expiresAt: Date.now() + ttlMs };
        this.mem.set(key, entry);
        try {
            localStorage.setItem(this.k(key), JSON.stringify(entry));
        } catch {
            // puede fallar en Safari Private Mode, etc.
        }
    }

    del(key: string) {
        this.mem.delete(key);
        try { localStorage.removeItem(this.k(key)); } catch { }
    }
}